<script>
export default {
  name: 'IconGraphPie',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0875 8.68726C26.2875 5.97476 24.025 3.71226 21.3125 2.91226C19.25 2.31226 17.825 2.36226 16.8375 3.09976C15.65 3.98726 15.5125 5.58726 15.5125 6.72476V9.83726C15.5125 12.9123 16.9125 14.4748 19.6625 14.4748H23.25C24.375 14.4748 25.9875 14.3373 26.875 13.1498C27.6375 12.1748 27.7 10.7498 27.0875 8.68726Z"
      :fill="color"
    />
    <path
      d="M23.6375 16.6999C23.3125 16.3249 22.8375 16.1124 22.35 16.1124H17.875C15.675 16.1124 13.8875 14.3249 13.8875 12.1249V7.64994C13.8875 7.16244 13.675 6.68744 13.3 6.36244C12.9375 6.03744 12.4375 5.88744 11.9625 5.94994C9.02499 6.32494 6.325 7.93744 4.56249 10.3624C2.7875 12.7999 2.1375 15.7749 2.7 18.7499C3.5125 23.0499 6.95 26.4874 11.2625 27.2999C11.95 27.4374 12.6375 27.4999 13.325 27.4999C15.5875 27.4999 17.775 26.7999 19.6375 25.4374C22.0625 23.6749 23.675 20.9749 24.05 18.0374C24.1125 17.5499 23.9625 17.0624 23.6375 16.6999Z"
      :fill="color"
    />
  </svg>
</template>
